import React from "react";
import { useSiteSettings } from "../context/SiteSettingsContext";
import { WHATSAPP_NUMBER } from "../lib/constants";

const WhatsAppButton = () => {
  const { settings } = useSiteSettings();
  const raw = settings?.contact?.whatsapp || WHATSAPP_NUMBER;
  const number = String(raw).replace(/[^0-9]/g, "");
  const link = `https://wa.me/${number}?text=${encodeURIComponent("Hi, I need help with my order.")}`;

  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-btn"
      className="fixed bottom-6 right-6 z-50 flex items-center justify-center h-14 w-14 rounded-full bg-[#25D366] text-white shadow-lg wa-pulse hover:scale-110 transition-transform"
      aria-label="Chat on WhatsApp"
      title="Need help? Chat with us"
    >
      <svg viewBox="0 0 32 32" className="h-8 w-8 fill-current" aria-hidden="true">
        <path d="M16.004 3C9.383 3 4 8.383 4 15.004c0 2.118.555 4.186 1.607 6.01L4 29l8.17-1.57a11.93 11.93 0 0 0 3.834.63h.001C22.62 28.06 28 22.677 28 16.056 28 9.435 22.62 3.05 16.004 3zm0 21.88h-.001a9.86 9.86 0 0 1-3.52-.646l-.252-.1-4.85.932.923-4.73-.164-.26a9.823 9.823 0 0 1-1.51-5.242c0-5.45 4.436-9.886 9.89-9.886 2.64 0 5.12 1.03 6.986 2.898a9.822 9.822 0 0 1 2.9 6.99c-.002 5.45-4.44 9.884-9.892 9.884zm5.42-7.4c-.297-.15-1.758-.868-2.03-.967-.273-.1-.472-.15-.67.15-.198.296-.767.967-.94 1.166-.173.198-.347.223-.644.074-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.76-1.653-2.057-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.148-.174.198-.298.297-.496.1-.198.05-.372-.025-.52-.074-.15-.67-1.612-.917-2.207-.242-.58-.487-.5-.67-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.478 0 1.462 1.065 2.875 1.213 3.073.148.198 2.095 3.2 5.076 4.487.71.306 1.263.49 1.695.627.712.227 1.36.195 1.872.118.571-.085 1.758-.718 2.006-1.412.248-.694.248-1.29.173-1.412-.074-.124-.272-.198-.57-.347z"/>
      </svg>
    </a>
  );
};

export default WhatsAppButton;
